<template>
  <div class="sub-form-date sub-columns">
    <BaseSwitcher
      class="sub-col"
      v-model="form.onlyDate"
      trueLabel="DATE"
      falseLabel="DATE & TIME"
      label="Options"
      fillSpace
    ></BaseSwitcher>

    <BaseSwitcher
      class="sub-col"
      v-model="form.format12h"
      trueLabel="12h"
      falseLabel="24h"
      label="Time format"
      fillSpace
    ></BaseSwitcher>
  </div>
</template>

<script>
  import subformMixin from '@/mixins/sub-form.mixin'

  export default {
    mixins: [ subformMixin ],
    data () {
      return {
        form: {
          onlyDate: false,
          format12h: true
        }
      }
    }
  }
</script>

<style lang="scss">
  @import './src/assets/styles/colors.scss';

  .sub-form-date {
  }
</style>


// WEBPACK FOOTER //
// src/components/forms/sub-forms/SubFormDate.vue